module.exports = __webpack_public_path__ + "images/sprites/ui/circle_arrow_bk_wh_0943ce6403174306a14d8261e8bd188a.png";